import { Grid, Link, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { ESimActivationModal } from "@features/ManageSim/ESimActivationModal";
import { IServiceWithESimToActivate } from "@features/ManageSim/interface/IServiceWithESimToActivate";

interface IParams {
    serviceWithESimToActivateList: IServiceWithESimToActivate[];
}

export const ESimActivation = (props: IParams) => {
    const { serviceWithESimToActivateList } = props;
    const { t } = useTranslation("sim");

    const [isESimActivationModalOpen, setIsESimActivationModalOpen] = useState(false);

    return (
        <>
            <Grid container spacing={{ xs: 0, sm: 2 }} style={{ width: "auto" }}>
                <Grid item sm={9} xs={12}>
                    <Stack justifyContent="space-between" spacing={2}>
                        <Typography
                            color="primary"
                            fontWeight="bold"
                            textAlign={{ xs: "center", sm: "left" }}
                            variant="h4"
                        >
                            {t("activateESim")}
                        </Typography>
                        <Typography textAlign={{ xs: "center", sm: "left" }} variant="normal">
                            {t("eSIMReady")}
                        </Typography>
                    </Stack>
                </Grid>
                <Grid item sm={3} xs={12}>
                    <Stack alignItems="end" direction="row" height="100%" justifyContent="center">
                        <Link
                            component="button"
                            underline="always"
                            width="fit-content"
                            onClick={() => setIsESimActivationModalOpen(true)}
                        >
                            <Typography align="center" color="primary">
                                {t("activateESim")}
                            </Typography>
                        </Link>
                    </Stack>
                </Grid>
            </Grid>
            {isESimActivationModalOpen && (
                <ESimActivationModal
                    isModalOpen={isESimActivationModalOpen}
                    serviceWithESimToActivateList={serviceWithESimToActivateList}
                    onClose={() => setIsESimActivationModalOpen(false)}
                />
            )}
        </>
    );
};
